/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import { useGoogleMap } from '@react-google-maps/api'
import debounce from 'lodash.debounce'
import { indonesiaBound } from './SetMapBound'

const MapResizeListener = ({ markers, breadcrumbs }) => {
  const maps = useGoogleMap()

  // Change map bound when resized
  const changeMapBound = useCallback(
    debounce(() => {
      if (maps) {
        // eslint-disable-next-line no-undef
        const bounds = new google.maps.LatLngBounds()

        if (breadcrumbs.length > 0) {
          markers.forEach(marker => {
            bounds.extend(marker.coordinate)
          })

          if (markers.length > 1) {
            maps.fitBounds(bounds, 50)
          } else {
            maps.fitBounds(bounds, 150)
          }
        } else {
          bounds.extend(indonesiaBound.northEast)
          bounds.extend(indonesiaBound.southWest)
          maps.fitBounds(bounds)
        }
      }
    }, 250),
    [maps, markers, breadcrumbs]
  )

  // Change the mobile interaction when on mobile
  const changeMapInteraction = debounce(() => {
      if (maps) {
        if (window.innerWidth < 767) {
          maps.setOptions({
            // panControl: true,
            // zoomControl: true,
            gestureHandling: 'auto',
          })
        } else {
          maps.setOptions({
            gestureHandling: 'none',
            // panControl: false,
            // zoomControl: false,
          })
        }
      }
  }, 250)

  useEffect(() => {
    changeMapInteraction()
    window.addEventListener('resize', changeMapInteraction)

    return () => {
      window.removeEventListener('resize', changeMapInteraction)
    }
  }, [])

  useEffect(() => {
    window.addEventListener('resize', changeMapBound)

    return () => {
      window.removeEventListener('resize', changeMapBound)
    }
  }, [changeMapBound])

  return null
}

MapResizeListener.propTypes = {
  markers: PropTypes.array.isRequired,
  breadcrumbs: PropTypes.arrayOf(PropTypes.array).isRequired
}

export { MapResizeListener }
